

export function getJSONValueUsingPath(obj, path){
  if(path==="")return obj;
  try {
    if (obj) {
      let pos = path.indexOf(".");
      if (pos < 0) {
        return obj[path];
      }
      else {
        let key = path.substring(0, pos);
        return getJSONValueUsingPath(obj[key], path.substring(pos + 1));
      }
    }
  }
  catch(err){
    console.log(err.message);
    console.log("Cannot find path \"" + path + "\" in object: " + JSON.stringify(obj));
  }
  return null;
}

export function getCamelCaseKey(key){
  // converts keys like "country-name" to keys like "countryName"

  let index=key.indexOf("-");
  while(index>=0){
    let before = key.substring(0,index);
    let after = key.substring(index+1);
    after = after.substring(0,1).toUpperCase() + after.substring(1);
    key = before + after;
    index = key.indexOf("-");
  }
  return key;
}

export function jsonObjectValidation(obj) {
  try {
    JSON.parse(obj);
    return true;
  }
  catch(err){
    return false;
  }
}

export function jsonStringToPrettyJsonString(jsonString){
  return JSON.stringify(JSON.parse(jsonString), null, 2);
}

export default{
  getJSONValueUsingPath,
  getCamelCaseKey,
  jsonObjectValidation,
  jsonStringToPrettyJsonString
}



// WEBPACK FOOTER //
// ./src/utils/JsonUtils.js